import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '@providers/api/api';


@Injectable()
export class StaffIdle {

  constructor(public api: Api) { }

  getStafIdle(params?:any){
    let req = this.api.get('index.php/activity/Idle/stafIdle',params);
    return req;
  }
}


// WEBPACK FOOTER //
// ./src/providers/activity/idle/provider.ts